var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBell = function SvgBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 7 9"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.783 4.905V3.087C5.783 1.89 4.942.895 3.84.7V.41A.405.405 0 0 0 3.443 0a.405.405 0 0 0-.397.411V.7C1.944.896 1.103 1.89 1.103 3.087v1.818A1.41 1.41 0 0 0 .132 6.26c0 .781.614 1.417 1.368 1.417h.82c.163.478.605.822 1.123.822s.96-.344 1.124-.822h.818c.755 0 1.369-.636 1.369-1.417 0-.639-.41-1.18-.971-1.356m-.398 1.95H1.5a.585.585 0 0 1-.573-.594c0-.328.257-.594.573-.594.22 0 .398-.185.398-.412V3.087c0-.882.693-1.6 1.545-1.6s1.545.718 1.545 1.6v2.168c0 .227.178.412.397.412.317 0 .574.266.574.594a.585.585 0 0 1-.574.594"
  })));
};
export default SvgBell;